<template>
  <div v-if="flux && flux.length">
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span>{{flux.length}} Flux</span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched" v-if="isSuperAdmin">
        <router-link :to="{name: 'FluxList'}" class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon"><i class="fal fa-list"></i></span>
          <span>Voir tous les flux</span>
        </router-link>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-last-fixed-small is-marginless-bottom">
      <thead>
        <tr class="is-size-6">
          <th>Date</th>
          <th>Réussis</th>
          <th v-if="isSuperAdmin">Erreurs</th>
          <th><span><span class="is-wrap-normal">Programmes Ajoutés</span></span></th>
          <th><span><span class="is-wrap-normal">Programmes Mis à jour</span></span></th>
          <th><span><span class="is-wrap-normal">Programmes Supprimés</span></span></th>
          <th><span><span class="is-wrap-normal">Lots Ajoutés</span></span></th>
          <th><span><span class="is-wrap-normal">Lots Mis à jour</span></span></th>
          <th><span><span class="is-wrap-normal">Lots Supprimés</span></span></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="f in flux" :key="f.pk" class="is-size-6 has-text-centered">
          <td class="is-narrow">{{f.created_on | prettyDatetime}}</td>
          <td class="has-text-centered">
            <span class="tag is-small is-radius-xlarge has-text-white is-success">{{countSuccess(f)}}</span>
          </td>
          <td class="has-text-centered" v-if="isSuperAdmin">
            <span class="tag is-small is-radius-xlarge has-text-white is-danger">{{countError(f)}}</span>
          </td>
          <td class="has-text-centered">{{f.program_added_number}}</td>
          <td class="has-text-centered">{{f.program_updated_number}}</td>
          <td class="has-text-centered">{{f.program_deleted_number}}</td>
          <td class="has-text-centered">{{f.lot_added_number}}</td>
          <td class="has-text-centered">{{f.lot_added_number_failed}}</td>
          <td class="has-text-centered">{{f.lot_deleted_number}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PromoteurFluxPanel',
    props: {
      flux: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapGetters(['isSuperAdmin'])
    },
    methods: {
      countError (e) {
        return e.program_added_number_failed +
          e.program_updated_number_failed +
          e.program_deleted_number_failed +
          e.lot_added_number_failed +
          e.lot_updated_number_failed +
          e.lot_deleted_number_failed
      },
      countSuccess (e) {
        return e.program_added_number +
          e.program_updated_number +
          e.program_deleted_number +
          e.lot_added_number +
          e.lot_updated_number +
          e.lot_deleted_number
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurFluxPanel.vue